/* eslint-disable angular/window-service */

window.storefrontAppDependencies = [
    'ui.bootstrap',
    'ngStorage',
    'ngCookies',
    'pascalprecht.translate',
    'ngSanitize',
    'credit-cards',
];

angular.module('storefrontApp', window.storefrontAppDependencies)
    .factory('httpErrorInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {
        function errorHandler(rejection) {
            if (rejection.data && rejection.data.message) {
                $rootScope.$broadcast('storefrontError', {
                    type: 'error',
                    title: [
                        rejection.config.method,
                        rejection.config.url,
                        rejection.status,
                        rejection.statusText,
                        rejection.data.message,
                    ].join(' '),
                    message: rejection.data.stackTrace,
                });
            }

            return $q.reject(rejection);
        }

        return {
            responseError: errorHandler,
            requestError: errorHandler,
        };
    }])

    .config(['$httpProvider', '$translateProvider', function ($httpProvider, $translateProvider) {
        $httpProvider.interceptors.push('httpErrorInterceptor');

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.useUrlLoader(window.BASE_URL + 'themes/localization.json');
        $translateProvider.preferredLanguage('en');
    }]);
